import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericService } from '@huge-monorepo/hip/services';
import { Endpoints } from '@huge-monorepo/hip/services';

@Component({
  selector: 'app-schedule-maintenance-dialog',
  templateUrl: './schedule-maintenance-dialog.component.html',
  styleUrls: ['./schedule-maintenance-dialog.component.scss'],
})
export class ScheduleMaintenanceDialogComponent implements OnInit {
  newDate = new Date();
  maintenanceForm: UntypedFormGroup = new UntypedFormGroup({
    hip: new UntypedFormControl(false, Validators.required),
    hicp: new UntypedFormControl(false, Validators.required),
    startTime: new UntypedFormControl(this.newDate, Validators.required),
    endTime: new UntypedFormControl(this.newDate, Validators.required),
  });
  constructor(
    public dialogRef: MatDialogRef<ScheduleMaintenanceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {},
    private endpoints: Endpoints,
    private genericService: GenericService,
  ) {}

  ngOnInit(): void {}

  sendMaintenance() {
    this.genericService
      .POST(this.endpoints.SCHEDULE_MAINTENANCE, {
        HIP: this.maintenanceForm.value.hip,
        HICP: this.maintenanceForm.value.hicp,
        StartTime: this.maintenanceForm.value.startTime,
        EndTime: this.maintenanceForm.value.endTime,
      })
      .subscribe({
        next: () => {
          this.genericService.createToast('Success', 'Successfully scheduled maintenance', 'success');
          this.dialogRef.close();
        },
        error: () => this.genericService.createToast('Error', 'Failed to schedule maintenance', 'error'),
      });
  }

  startUpdated(date: Date) {
    this.maintenanceForm.controls['startTime'].setValue(date);
  }

  endUpdated(date: Date) {
    this.maintenanceForm.controls['endTime'].setValue(date);
  }
}
